export enum ELogTypes {
  STATE_CHANGED = "STATE CHANGED",
  API = "API CALL",
  GEO_LOC_EVENT = "GEOLOC LOOKUP",
  MAP_CLICK = "MAP CLICK",
  SEARCH = "SEARCH",
  ERROR = "ERROR",
}

export enum EGoogleEventTypes {
  MAP_MARKER_CLICKED = "Map Marker",
  REPORT_OUTAGE_CLICKED = "REPORT_OUTAGE_CLICKED",
  OUTAGE_SUBMITTED = "OUTAGE_SUBMITTED",
  SEARCH = "SEARCH_QUERY",
  CLOSE_BUTTON_CLICKED = "CLOSE_BUTTON_CLICKED",
  CANCEL_BUTTON_CLICKED = "CANCEL_BUTTON_CLICKED",
  BACK_TO_MAP_CLICKED = "BACK_TO_MAP_CLICKED",
  ERROR = "ERROR",
}
